import { cache } from "../constants/pwa";

export const isPwaInstalled = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};

export const pwaInstall = async (
  setIsInstall?: () => void,
  onAlreadyInstalled?: () => void,
) => {
  if (!cache["root"]) return;
  if (isPwaInstalled()) {
    onAlreadyInstalled?.();
    return;
  }
  await cache["root"].prompt();
  cache["root"]?.userChoice.then(
    (choiceResult: { outcome: "accepted" | "dismissed" }) => {
      if (choiceResult.outcome === "accepted") {
        setIsInstall?.();
      }
    },
  );
};
